<template>
  <div class="subscription-tariff-card" :class="{ _active: tariff.is_current }">
    <div
      class="subscription-tariff-card__header"
      :style="{ backgroundColor: tariff.header_bg_color, color: tariff.header_text_color }"
    >
      <div class="subscription-tariff-card__title">
        <div v-if="tariff.is_current" class="subscription-tariff-card__header-check">
          <BaseSvg name="ico-check" width="1rem" height="0.8rem" />
        </div>
        <span>{{ tariff.name }}</span>
      </div>
      <div
        v-if="tariff.is_current"
        class="subscription-tariff-card__subtitle"
      >
        {{ $tAccountSubscription('current_tariff') }}
      </div>
    </div>

    <div class="subscription-tariff-card__list">
      <SubscriptionTariffCardItem :value="tariff.value.publications" :description-item="descriptionItems[0]" />
      <SubscriptionTariffCardItem :value="tariff.value.open_contacts" :description-item="descriptionItems[1]" />
      <SubscriptionTariffCardItem :value="tariff.value.top_up_vacancies" :description-item="descriptionItems[2]" />
      <SubscriptionTariffCardItem :value="tariff.value.hot_vacancies" :description-item="descriptionItems[3]" />
      <!--    TODO temp hide  -->
      <!--      <SubscriptionTariffCardItem :value="tariff.value.automatic_mailing" :description-item="descriptionItems[4]" />-->
    </div>

    <div class="subscription-tariff-card__price">{{ tariff.price }}</div>
    <div class="subscription-tariff-card__duration">{{ tariffDurationText }}</div>

    <div class="subscription-tariff-card__action">
      <button
        class="subscription-tariff-card__action-btn base-btn base-btn--blue"
        :disabled="!tariff.can_purchase"
        @click="$emit('purchase', tariff)"
      >
        {{ purchaseBtnText }}
      </button>
    </div>
  </div>
</template>

<script>
import SubscriptionTariffCardItem from './SubscriptionTariffCardItem';

export default {
  name: 'SubscriptionTariffCard',
  components: {
    SubscriptionTariffCardItem,
  },
  props: {
    tariff: {
      type: Object,
      required: true,
    },
    descriptionItems: {
      type: Array,
      required: true,
    },
  },
  computed: {
    tariffDurationText() {
      if (this.tariff.is_current) return `${this.$tAccountSubscription('days_left')}: ${this.tariff.days_left}`;
      return this.tariff.tariff_duration;
    },
    purchaseBtnText() {
      const translateKey = this.tariff.is_current ? 'extend' : 'connect_tariff';
      return this.$tAccountSubscription(translateKey);
    },
  },
};
</script>
